module.exports = __webpack_public_path__ + "img/Trustpilot_brandmark_blk_RGB.9af72f85.svg";